<template>

    <div class="loginPage cardBox">
        <div class="cardBody">


            <dl>
                <dd>
                    <p>昵称</p>
                    <label class="inputItem">
                        <input type="text" v-model="param.nickName" placeholder="请输入昵称"></input>
                    </label>
                </dd>
                <dd>
                    <p>账号</p>
                    <label class="inputItem">
                        <input type="text" v-model="param.username" placeholder="请输入账号"></input>
                    </label>
                </dd>
                <dd>
                    <p>密码</p>
                    <label class="inputItem">
                        <input type="password" v-model="param.password" placeholder="请输入密码"></input>
                    </label>
                </dd>
                <dd>
                    <p>确认密码</p>
                    <label class="inputItem">
                        <input type="password" v-model="password" placeholder="请输入密码"></input>
                    </label>
                </dd>
                <dd>
                    <p>性别</p>
                    <label class="inputItem">
                        <label class="inputItem">
                            <select v-model="param.sex">
                                <option value="0">未知</option>
                                <option value="1">男</option>
                                <option value="2">女</option>
                            </select>
                        </label>
                    </label>
                </dd>
                <dd>
                    <p>身份证</p>
                    <label class="inputItem">
                        <input type="text" v-model="param.idCard" placeholder="请输入身份证"></input>
                    </label>
                </dd>
                <dd>
                    <p>邮箱</p>
                    <label class="inputItem">
                        <input type="text" v-model="param.email" placeholder="请输入邮箱"></input>
                    </label>
                </dd>
                <dd>
                    <p>电话</p>
                    <label class="inputItem">
                        <input type="text" v-model="param.phone" placeholder="电话号码"></input>
                    </label>
                </dd>
                <dd>
                    <p>地址</p>
                    <label class="inputItem">
                        <input type="text" v-model="param.address" placeholder="请输入地址"></input>
                    </label>
                </dd>
                <dd>
                    <p>创建人</p>
                    <label class="inputItem">
                        <input type="text" v-model="param.createdBy" placeholder="请输入创建人"></input>
                    </label>
                </dd>
                <dd>
                    <p>状态</p>
                    <label class="inputItem">
                        <select v-model="param.status">
                            <option value="1">启用</option>
                            <option value="2">停用</option>
                        </select>
                    </label>
                </dd>
                <dd>
                    <p>角色</p>
                    <label class="inputItem">
                        <select v-model="param.roleId">
                            <option value="0">普通用户</option>
                            <option value="1">管理员</option>
                        </select>
                    </label>
                </dd>
                <dd>
                    <button class="send" @click="goRegist">注册</button>
                    <button class="login" @click="goLogin">返回登录</button>
                </dd>
            </dl>





        </div>

        <div class="footer">
            <p>Copyright © 2019 北京华健蓝海医疗科技有限责任公司. All rights reserved.</p>
        </div>
    </div>

</template>


<style lang="scss" scoped>
    @import './regist.scss';
</style>


<script>
    export default {
        data() {
            return {
                password: '',
                param: {
                    username: '',
                    password: '',
                    nickName: '',
                    sex: 0,
                    idCard: '',
                    email: '',
                    phone: '',
                    address: '',
                    createdBy: '',
                    status: 1,
                    roleId: 1,
                },
                isSave: '',
                autoLogin: '',
            }
        },
        components: {

        },
        created() {
            let that = this;


        },
        mounted() {
            let that = this;
        },
        methods: {


            goRegist() {
                let that = this;
                that.param.password=that.md5(that.param.password);
                that.password=that.md5(that.password);
                if (that.param.nickName == "") {
                    that.$dialog.alert({
                        message: '请输入昵称',
                    });
                    return;
                }
                if (that.param.username == "") {
                    that.$dialog.alert({
                        message: '请输入账号',
                    });
                    return;
                }
                if (that.param.password == "") {
                    that.$dialog.alert({
                        message: '请输入密码',
                    });
                    return;
                }
                if (that.param.password != that.password) {
                    that.$dialog.alert({
                        message: '密码不一致',
                    });
                }

          
                that.ajax.post('user/add', that.param).then(res => {
                    that.$dialog.confirm({
                        message: '创建成功，是否跳转到登录？',
                    }).then(() => {
                        that.$router.replace({ name: 'Login' });
                    });
                })
            },
            goLogin() {
                that.$router.replace({ name: 'Login' });
            }

        },
    }
</script>